import React, { useEffect, useMemo } from 'react'
import StaffTable, { MEMBERS_PER_PAGE } from '../../components/StaffTable/StaffTable'
import CustomPagination from '../../../../components/Pagination/CustomPagination'

// staffCurrentPage/setStaffCurrentPage are owned by TeamOverview (the parent
// that stays mounted across tab switches) rather than local state here, so
// the page you're on survives switching to Application View and back.
const StaffView = ({ groupedOfficers, stageColumns, handlePageChange, branchApplicationFilters, setBranchApplicationFilters, staffCurrentPage, setStaffCurrentPage }) => {
    const storedBranchwiseAppFilters = JSON.parse(sessionStorage.getItem("bwApplicationListFilters"));

    const staffTotalPages = useMemo(() => {
        const longestGroupLength = Math.max(
            0,
            ...(groupedOfficers?.map((group) => group.officers.length) || [])
        );
        return Math.max(1, Math.ceil(longestGroupLength / MEMBERS_PER_PAGE));
    }, [groupedOfficers]);

    // The branch (or any other top-level) filter can change the officer
    // roster under our feet - keep the page in range instead of showing a
    // blank table on a page that no longer exists.
    useEffect(() => {
        if (staffCurrentPage > staffTotalPages) {
            setStaffCurrentPage(staffTotalPages);
        }
    }, [staffCurrentPage, staffTotalPages]);

    useEffect(() => {
        let filter = {
            current_application_bucket: "",
            branch_code: storedBranchwiseAppFilters?.branch_code || "",
            ro_employee_ids: [],
            bm_employee_ids: [],
            bcm_employee_ids: [],
        }

        sessionStorage.setItem("branchApplicationFilters", JSON.stringify(filter));
    }, [storedBranchwiseAppFilters?.branch_code]);

  return (
    <div>
        {/* Data Table */}
        <div className="tableCard">
            <div className="teamOverviewTableContainer">
                <StaffTable
                    groupedOfficers={groupedOfficers}
                    stageColumns={stageColumns}
                    currentPage={staffCurrentPage}
                    handlePageChange={handlePageChange}
                    branchApplicationFilters={branchApplicationFilters}
                    setBranchApplicationFilters={setBranchApplicationFilters}
                />
            </div>
        </div>

        {staffTotalPages > 1 && (
            <div className="paginationControls">
                <CustomPagination
                    currentPage={staffCurrentPage}
                    totalPages={staffTotalPages}
                    onPageChange={setStaffCurrentPage}
                />
            </div>
        )}
    </div>
  )
}

export default StaffView
